import React from 'react';

import './formFooter.css';

const FormFooter = () => (
  <div className="text-center footer">
    <img alt="workast logo" src="https://cdn.workast.io/avatar.png" className="avatar" width="35" />
    <p>
      This form was created with Workast.
      <br />
      <a target="blank" href="https://www.workast.com?utm_source=form_page">
        AI-driven task management for growing biz
      </a>
    </p>
  </div>
);

export default FormFooter;
